package com.wintermar.inspection.feature.domain.model.inspection

import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.graphql.type.InspectionStatus

data class InspectionModel(
    val id: String = "",
    val templateId: String = "",
    val templateName: String = "",
    val vesselName: String = "",
    val lastUpdated: String = "",
    val totalAnswer: Int = 0,
    val totalQuestion: Int = 0,
    val status: InspectionStatus = InspectionStatus.UNKNOWN__,
    val conducted: String = "",
    val template: InspectionTemplateModel = InspectionTemplateModel()
)

data class InspectionLandingModel(
    val data: List<InspectionModel> = emptyList(),
    val total: Int = 0
)
